const storageKey = (key: string) => `gaia-bootstrap:${key}`;

// localStorage peut être vide, plein ou indisponible (navigation privée) : dans tous ces cas
// on recharge depuis l'API, comme avant le cache. Une entrée périmée est ignorée par sa version.
export const readCached = <T>(key: string, version: string|null): T|null => {
  if (!version) {
    return null;
  }
  try {
    const raw = localStorage.getItem(storageKey(key));
    if (!raw) {
      return null;
    }
    const cached = JSON.parse(raw) as CachedPayloadInterface<T>;

    return cached.version === version ? cached.data : null;
  } catch {
    return null;
  }
};

export const writeCached = (key: string, version: string|null, data: unknown): void => {
  if (!version) {
    return;
  }
  try {
    localStorage.setItem(storageKey(key), JSON.stringify({ version, data }));
  } catch {
    // Quota dépassé ou stockage indisponible : le prochain chargement repassera par l'API.
  }
};
